import { TVariableDetailRow, TSourceManagementVariables } from '../type/source-management'
import {
  TSwitchManagementEntityName,
  TSwitchManagementRowToEdit,
  TSwitchManagements,
  TSwitchSourceRowToArchive,
  TSwitchToCreate,
  TSwitchToUpdate,
} from '../type/switch-management'
import { customErrorResponse } from '../utility/custom-error-response'
import { request, resetCustomOnResponseError, setCustomOnResponseError } from './axios'

export const Switch = {
  get: async (search_key = '', page = 1): Promise<TSwitchManagements> => {
    const searchParam = search_key ? `&search=${search_key}` : ''
    const typeParam = '&logic=Switch_Mappings'
    const {
      data: { logic_mappings, max_page_size, page_number, total_count, total_pages },
    } = await request({
      url: `/category-classification/logic-mapping/management/?page_number=${page}${searchParam}${typeParam}`,
    })

    return {
      logic_mappings,
      max_page_size,
      page_number,
      total_count,
      total_pages,
    }
  },
  archive: async (switchMapping: string) => {
    const typeParam = '&logic=Switch_Mappings'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'delete',
      url: `/category-classification/logic-mapping/management/?name=${switchMapping}${typeParam}`,
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
  getVariableDetails: async (
    sourceName: string,
    type: string,
    search_key?: string,
    includeTerminated = false,
  ): Promise<{ variable_details: TVariableDetailRow[] }> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const searchParam = search_key ? `&search=${search_key}` : ''
      const typeParam = '&logic=Switch_Mappings'

      const {
        data: { variable_details },
      } = await request({
        url: `/category-classification/logic-mapping/management/variable/?include_terminated=${includeTerminated}&type=${type}&category=${sourceName}${searchParam}${typeParam}`,
      })
      return {
        variable_details,
      }
    } finally {
      resetCustomOnResponseError()
    }
  },
  getConfig: async (): Promise<TSourceManagementVariables> => {
    const typeParam = 'logic=Switch_Mappings'
    const {
      data: { configs },
    } = await request({
      url: `/category-classification/logic-mapping/configuration/?${typeParam}`,
    })

    return {
      configs,
    }
  },

  getNameById: async (variable: string, entity_id: string): Promise<TSwitchManagementEntityName> => {
    const {
      data: { entity_name },
    } = await request({
      url: `/category-classification/logic-mapping/management/entity-meta/?type=${variable}&id=${entity_id}`,
    })
    return {
      entity_name,
    }
  },

  updateSwitch: async (payloadToUpdate: TSwitchToUpdate) => {
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'patch',
      url: '/category-classification/logic-mapping/management/',
      data: {
        ...payloadToUpdate,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  createSwitch: async (payloadToCreate: TSwitchToCreate) => {
    const typeParam = 'logic=Switch_Mappings'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'post',
      url: `/category-classification/logic-mapping/management/?${typeParam}`,
      data: {
        ...payloadToCreate,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  updateRow: async (row: TSwitchManagementRowToEdit) => {
    const typeParam = 'logic=Switch_Mappings'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'patch',
      url: `/category-classification/logic-mapping/management/row/?${typeParam}`,
      data: {
        ...row,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  removeRow: async (payloadToRemove: TSwitchSourceRowToArchive) => {
    const typeParam = '&logic=Switch_Mappings'
    console.log(payloadToRemove)
    setCustomOnResponseError(customErrorResponse)
    const { effective_start_date, id, type, category } = payloadToRemove

    return request({
      method: 'delete',
      url: `/category-classification/logic-mapping/management/row/?category=${category}&type=${type}&id=${id}&effective_start_date=${effective_start_date}${typeParam}`,
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
}
